import React from 'react';

import { LoadingButton } from '@mui/lab';
import { Typography } from '@mui/material';
import { useExportPdf } from 'src/florence/hooks/useExportPdf';

import { ReactComponent as ExportIconBlue } from '../assets/icons/export_icon_blue.svg';
import { SelectableCode } from '../types/Codes';
import { SaveSheet } from '../types/SaveSheet';

type Props = {
  isDisabled: boolean;
  note: SaveSheet;
  small?: boolean;
  selectedCodes?: SelectableCode[];
};

const ExportPDFButton: React.FC<Props> = ({
  isDisabled,
  note,
  small,
  selectedCodes,
}) => {
  const { exportPdf, exportIsLoading } = useExportPdf();

  return (
    <LoadingButton
      loading={exportIsLoading}
      disabled={isDisabled}
      onClick={() => exportPdf(note, selectedCodes)}
      variant='outlined'
      startIcon={<ExportIconBlue />}
      color='darkBlue'
      sx={{
        borderRadius: '50px',
        width: small ? '146px' : '146px',
        height: small ? '40px' : '50px',
      }}
    >
      <Typography>Export PDF</Typography>
    </LoadingButton>
  );
};

export default ExportPDFButton;
